/* eslint-disable */
export const SET_TIMESTAMP_DIFF = 'set_timestamp_diff';
export const RECEIVE_SETTINGS = 'receive_settings';
export const RECEIVE_WARAHOUSES = 'receive_warahouses';
export const RECEIVE_SHIPPING_TYPES = 'receive_shipping_types';
export const SET_TOKEN = 'set_token';
export const RECEIVE_USER_TOKEN = 'receive_user_token';
export const SET_EXPIRE_TIME = 'set_expire_time';
export const REMOVE_TOKEN = 'remove_token';
export const REVEIVE_IDENTITY = 'reveive_identity';
export const RECEIVE_AD = 'receive_ad';
export const RECEIVE_INFORMATIONS = 'receive_informations';
export const RECEIVE_INFORMATION_DETAIL = 'receive_information_detail';
export const RECEIVE_WEBSITES = 'receive_websites';
export const RECEIVE_WEBSITES_CATEGORIES = 'receive_websites_categories';
export const RECEIVE_WEBSITES_ZONES = 'receive_websites_zones';
export const RECEIVE_SHARES = 'receive_shares';
export const RECEIVE_SHARE_DETAIL = 'receive_share_detail';
export const RECEIVE_SHARE_COMMENT = 'receive_share_comment';
export const RECEIVE_SHARE_COMMENT_DETAIL = 'receive_share_comment_detail';
export const RECEIVE_REDEMPTION_CENTER = 'receive_redemption_center';
export const RECEIVE_NEW_PARCEL_CLAIM = 'receive_new_parcel_claim';
export const RECEIVE_PARCEL_CLAIM = 'receive_parcel_claim';
export const REMOVE_CLAIM = 'remove_claim';
export const RECEIVE_PARCEL = 'receive_parcel';
export const RECEIVE_PARCEL_DETAIL = 'receive_parcel_detail';
export const RECEIVE_TRANSPORT_SERVICES = 'receive_transport_services';
export const RECEIVE_TRANSPORT_SERVICES_CATEGORIES = 'receive_transport_services_categories';
export const RECEIVE_PARCEL_COUNT = 'receive_parcel_count';
export const RECEIVE_OVERSEAS_WAREHOUSES = 'receive_overseas_warehouses';
export const RECEIVE_BALANCES = 'receive_balances';
export const RECEIVE_ORDERS = 'receive_orders';
export const RECEIVE_ORDER_DETAIL = 'receive_order_detail';
export const RECEIVE_ORDER_UNPAID_COUNT = 'receive_order_unpaid_count';
export const RECEIVE_ADDRESS = 'receive_address';
export const RECEIVE_NEW_ADDRESS = 'receive_new_address';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js